import { CheckIcon, ReloadIcon } from "@radix-ui/react-icons"
import { useFetcher } from "@remix-run/react"
import { useEffect, useState } from "react"
import { loader } from "~/routes/_app+/following"
import { Button } from "~/components/ui/button"
import { UsersStars } from "@prisma/client"

export function FollowButton({
  className,
  starID,
  follow,
}: {
  className?: string
  starID: number
  follow: UsersStars
}) {
  const fetcher = useFetcher<typeof loader>()
  const [submitting, setSubmitting] = useState(false)
  const [following, setFollowing] = useState(!!follow)

  useEffect(() => {
    setSubmitting(fetcher.state == "submitting")
    if (fetcher.data) {
      setFollowing(!!fetcher.data.follow)
    }
  }, [fetcher.state])

  return (
    <fetcher.Form
      className="flex items-center"
      action={`/following?starID=${starID}`}
      method={following ? "delete" : "post"}>
      {submitting ?
        <Button className={className} disabled={true}>
          <ReloadIcon className="inline mr-2 h-4 w-4 animate-spin" />
          Following...
        </Button>
      : <Button className={className} type="submit">
          {following ?
            <>
              <CheckIcon className="mr-2 h-4 w-4" /> Following
            </>
          : <>Follow</>}
        </Button>
      }
    </fetcher.Form>
  )
}
